var $16ec4ffbd4b2ca4b$exports = {};
$16ec4ffbd4b2ca4b$exports = {
    "(optional)": `(valikuline)`,
    "(required)": `(n\xf5utav)`
};


export {$16ec4ffbd4b2ca4b$exports as default};
//# sourceMappingURL=et-EE.module.js.map
